import React from 'react';
import PropTypes from 'prop-types';
import TrackedButton from '../Buttons/TrackedButton';

const MultiBoardsCollapsibleHeaderTitle = ({ buttons, onLivecamChange }) => (
  <span className="row" style={{ marginRight: 30 }}>
    <span className="col d-flex flex-wrap" style={{ gap: '14px' }}>
      {buttons.map(({ isActive, livecamId, livecamIndexes }) => (
        <TrackedButton
          name="board-button"
          className={`u-font-foundation-roman px-2 py-1 text-uppercase ${isActive ? 'text-white' : 'text-dark'}`}
          style={{
            border: '1px solid #969696',
            backgroundColor: isActive ? '#79797A' : 'transparent',
            letterSpacing: '0.04em',
            borderRadius: 10,
            fontSize: 16,
          }}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            if (!isActive) {
              onLivecamChange(livecamId);
            }
          }}
          title={livecamIndexes.length === 4 ? 'Board Comments' : `Board ${livecamIndexes.join('&')} Comments`}
          action="Toggle board comments"
          key={livecamId}
          id={`board-${livecamId}-button`}
        />
        ))}
    </span>
    <span className="col-auto ml-auto">
      <TrackedButton
        className="btn btn-sm btn-link text-dark p-0"
        style={{ width: 30 }}
        type="link"
        to="/help"
        title={'Go to frequently asked questions'}
        action="Clicked FAQ icon"
      >
        <img
          src="https://media.explore.org/logos/faq-1589482168935.svg"
          className="clickable"
          alt="Frequently asked questions"
          style={{ width: '100%' }}
        />
      </TrackedButton>
    </span>
  </span>
);

MultiBoardsCollapsibleHeaderTitle.propTypes = {
  buttons: PropTypes.arrayOf(PropTypes.shape({
    livecamId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    livecamIndexes: PropTypes.arrayOf(PropTypes.number),
    isActive: PropTypes.bool,
  })).isRequired,
  onLivecamChange: PropTypes.func.isRequired,
};

MultiBoardsCollapsibleHeaderTitle.defaultProps = {
  activeLivecamId: null,
};

export default MultiBoardsCollapsibleHeaderTitle;
